export default __webpack_public_path__ + "static/media/Roboto-Thin.62fa42c2.woff";